import {
    EmbedContext,
} from 'components/EmbedContext'
import {EmbedEvents} from 'embed/types/events'
import {useContext} from 'react'


export const sendToParent = (event: EmbedEvents, sessionKey: string) => {
    if (window.parent) {
        const {
            targetOrigin,
            ...message
        } = event


        window.parent.postMessage(JSON.stringify({
            ...message,
            sessionKey,
        }), targetOrigin)
    }
}

export const useSendToParent = () => {
    const embedConfig = useContext(EmbedContext)

    return (event: EmbedEvents) => sendToParent(event, embedConfig?.sessionKey || '')
}


